import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker' 
import logout from './../../Global/logout' 

export default async function PutNaplatniUredaj(
        clientUuid, 
        data,
        businessPremisesUuid

    ) {
    const unHashedJwt = await checkJwt()
 
    if(!unHashedJwt){
        logout()
    }

    return await resolve(
        axios( 'provider/client/device/' +  data.uuid + "?clientUuid=" + clientUuid, {
            method: 'PUT',
            headers: { 'Authorization' : unHashedJwt.data},
            data: {
                "tid": data.tid?.trim(),
                "label": data.label?.trim(),
                "isuNumber": data.ecommerce ? undefined : data.isuNumber?.trim(),
                "description": data.description?.trim(),
                "businessPremisesUuid": businessPremisesUuid?.trim(),
                "ecommerce": data.ecommerce,
            }      
        }).then(
            res => (res)
        ).catch(error => error.response.data),
        "Admin"
    )
}